/** Carousel */
$('#carousel_custom').on('slide.bs.carousel', function (e) {
    var $this = $(this);
    var $e = $(e.relatedTarget);
    var idx = $e.index();
    var itemsPerSlide = 4;
    var carouselIner = $this.find('.carousel-inner');
    var totalItems = $this.find('.carousel-item').length;

    if (idx >= totalItems-(itemsPerSlide)) {
        var it = itemsPerSlide - (totalItems - idx);
        for (var i=0; i<it; i++) {
            // append slides to end
            if (e.direction=="left") {
                $this.find('.carousel-item').eq(i).appendTo(carouselIner);
            }
            else {
                $this.find('.carousel-item').eq(0).appendTo(carouselIner);
            }
        }
    }
});